import React from 'react';
import styled from 'styled-components';
import ImpContainer from '../ImpContainer/ImpContainer';
const Image = styled.img `
  display: block;
  height: ${(props) => props.height || 'auto'};
  width: ${(props) => props.width || 'auto'};
  object-fit: ${(props) => props.objectFit || 'cover'};
  border-radius: ${(props) => props.borderRadius || '0'};
`;
/**
 * An image component for displaying images.
 *
 * @param {string} props.src - The source URL of the image.
 * @param {string} props.alt - The alternative text of the image.
 * @param {string} [props.height='auto'] - The height of the image.
 * @param {string} [props.width='auto'] - The width of the image.
 * @param {boolean} [props.draggable=false] - Whether the image is draggable.
 *
 * @returns The ImpImage component.
 */
export default function ImpImage({ dataTestId = 'image', draggable = false, objectFit, borderRadius, src, alt, height, width, ...props }) {
    return (React.createElement(ImpContainer, { height: height, width: width, borderRadius: borderRadius },
        React.createElement(Image, { "data-testid": dataTestId, src: src, alt: alt, height: height, draggable: draggable, width: width, objectFit: objectFit, borderRadius: borderRadius, ...props })));
}
//# sourceMappingURL=ImpImage.js.map